<div class="container mt-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-contract.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ 'preguntas.titulo' | translate }}</h2>
    </div>
  </div>
  <!-- Barra de búsqueda -->
  <div class="row my-3">
    <div class="col-12 d-flex justify-content-end">
      <div class="col-12">
        <div class="govco-search-basic">
          <div class="container-govco d-flex" id="containter-default">
            <input
              type="text"
              class="input-search-basic-govco"
              [placeholder]="'preguntas-frecuentes.buscar-terminos' | translate"
              aria-label="buscador"
              [(ngModel)]="pregunta"
              (input)="buscarPregunta()" />
            <button
              class="btn-clean-basic-govco me-2"
              type="button"
              id="btn-clean-basic"
              aria-label="Limpiar">
              <span class="govco-svg govco-times"></span>
            </button>
            <div class="line-basic-govco"></div>
            <button class="btn-search-basic-govco" type="button"
              aria-label="Buscar">
              <span class="govco-svg govco-search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4">
    <div class="d-flex justify-content-end">
      <button class="btn-govco outline-btn-govco ms-2"
       [attr.aria-label]="'preguntas.crear_pregunta' | translate"
       (click)="crearPregunta()">
        {{ 'preguntas.crear_pregunta' | translate }}
      </button>
    </div>
  </div>
    <div
    class="accordion-govco mt-5"
    [id]="'faqAccordion' + categoria"
    *ngFor="let categoria of categoriasKeys; let j = index">
    <div class="d-flex flex-row align-items-center mb-3">
      <i
        class="fa fa-folder-open-o fa-lg color__cobalt me-2"
        aria-hidden="true"></i>
      <h5 class="color__cobalt mb-0" *ngIf="categoria">{{ categoria }}</h5>
    </div>
    <div
      class="item-accordion-govco"
      *ngFor="let pregunta of categorias.get(categoria); let i = index">
      <h2
        class="accordion-header d-flex justify-content-between align-items-center"
        [attr.id]="'heading' + i + 'c' + j">
        <button
          class="button-accordion-govco"
          type="button"
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse' + i + 'c' + j"
          aria-expanded="false"
          [attr.aria-controls]="'collapse' + i + 'c' + j"
          [attr.aria-label]="'Ver respuesta pregunta frecuente'">
          <div class="d-flex flex-row align-items-center justify-content-between w-100">
            <span class="pregunta-texto text3-tipografia-govco">{{
              pregunta.Pregunta_Frecuente
            }}</span>
            <div class="button-editar-preguntas" *ngIf="mostrarIconoEditar">
              <button class="btn btn-link p-0 me-2" (click)="editarPregunta(pregunta)"
                aria-label="Editar pregunta frecuente"
                title="Editar pregunta frecuente">
                <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i>
              </button>
              <button class="btn btn-link p-0" (click)="editarEstadoPregunta(pregunta)"
                aria-label="Estado pregunta frecuente"
                title="Editar Estado pregunta frecuente"
                >
                <i class="fa fa-power-off fa-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </button>
      </h2>
      <div
        [attr.id]="'collapse' + i + 'c' + j"
        class="accordion-collapse collapse"
        [attr.aria-labelledby]="'heading' + i + 'c' + j"
        [attr.data-bs-parent]="'#faqAccordion' + categoria">
        <div class="body-accordion-govco">
          <p
            class="text-one-accordion-govco"
            [innerHTML]="pregunta.Respuesta"></p>
          <a
            class="text-one-accordion-govco link-tipografia-govco link-color hvr-forward"
            target="_blank"
            *ngIf="pregunta.esEnlace"
            routerLink="{{ pregunta.enlace }}">
            {{ pregunta.textoEnlace }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-form-editar-preguntas-frecuentes
    (preguntaActualizada)="buscarPregunta()">
  </app-form-editar-preguntas-frecuentes>
</div>
